import { usePocQuery } from 'core/custom-hooks/use-poc-query.hook';
import { settingsKeys } from 'core/query-client/keys/settings.keys';
import { executeRequest } from 'core/utils/backend-service';
import { getSinglePredefinedComment } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/service/predefined-comments.service';

// Loads a single predefined comment for the edit form. `enabled` gates on a real (non-"new") id.
export const usePredefinedCommentFetcher = (id?: string) => {
    const isEditId = !!id && id !== 'new';

    const {
        data: predefinedComment,
        isFetching,
        isError,
    } = usePocQuery({
        queryKey: settingsKeys.predefinedCommentDetail(id),
        queryFn: () => executeRequest(() => getSinglePredefinedComment(id!)),
        enabled: isEditId,
    });

    return { predefinedComment, isFetching, isError };
};
